import React from 'react';
import EditorTestResultOverview from './editorTestResultOverview';

class EditTestResultOverview extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<div className="lit-modal" onClick={() => this.props.onCancel()}>
				<div
					className="lit-modal__other"
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<div>
						<EditorTestResultOverview
							onEditModelConfirm={this.props.onConfirm}
							onEditModelCancel={this.props.onCancel}
							selectedTestUser={this.props.selectedTestUser}
							getTestsBySearch={this.props.getTestsBySearch}
							selectedId={this.props.selectedId}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default EditTestResultOverview;
